






























import { Component, Prop, Vue } from "vue-property-decorator";
import { LayoutModule } from "@/store/layout";
import { ReportModule } from "@/store/report";
import DatePicker from "@/components/DatePicker.vue";
import moment from "moment";
import CAMPAIGN_STATUS_LIST from "@/constants/campaign";

@Component({
  components: {
    DatePicker,
  },
})
export default class CampaignsReportFilter extends Vue {
  dates: string[] = [ReportModule.start, ReportModule.end];
  statuses: string[] = [];
  statusList = CAMPAIGN_STATUS_LIST;

  cancel(): void {
    LayoutModule.hideRightDrawer();
  }

  applyFilter(): void {
    ReportModule.setStartFilter(this.dates[0]);
    ReportModule.setEndFilter(this.dates[1]);
    LayoutModule.hideRightDrawer();
  }
}
